/* design: .grid-360 — minmax(0,1.55fr) minmax(0,1fr), 16px gap, collapse <1000px */
.grid360 {
  display: grid;
  grid-template-columns: minmax(0, 1.55fr) minmax(0, 1fr);
  gap: var(--spacing-4);
  align-items: start;
}

@media (max-width: 1000px) {
  .grid360 {
    grid-template-columns: 1fr;
  }
}

.stack {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-4);
}

.statGrid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--spacing-4);
  align-items: start;
}

/* design: button styled as .card.card--pad with an inner .row.gap-12 */
.statCard {
  display: flex;
  align-items: center;
  gap: var(--spacing-3);
  text-align: left;
  border: none;
  cursor: pointer;
  font-family: inherit;
  background: var(--color-white);
  border-radius: var(--card-border-radius, 16px);
  box-shadow: var(--box-shadow);
  padding: var(--pad-card, var(--spacing-5));
  transition: transform 0.12s;
}

.statCard:hover {
  transform: translateY(-1px);
}

/* non-interactive KPI tiles (no meaningful navigation target) */
.statCardStatic {
  cursor: default;
}

.statCardStatic:hover {
  transform: none;
}

/* design: .diag__ic — 34px square, radius 9px */
.statIcon {
  width: 34px;
  height: 34px;
  border-radius: 9px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: var(--color-primary-lightest);
  color: var(--color-primary);
}

.statIconWarn {
  background: var(--color-warning-lightest);
  color: var(--color-warning);
}

.statIconOk {
  background: var(--color-success-lightest);
  color: var(--color-success);
}

.statValue {
  font-size: var(--font-size-xxl);
  line-height: 1;
  font-variant-numeric: tabular-nums;
  color: var(--color-text);
}

/* design: .muted.text-sm.mt-2 — 13px grey, 8px top margin */
.statLabel {
  font-size: var(--font-size-m);
  color: var(--color-grey);
  margin-top: 8px;
}

/* design: .card-body--flush inner wrapper = padding 4px 8px */
.attnList {
  padding: 4px 8px;
}

/* design: .cmd__res */
.attnRow {
  display: flex;
  align-items: center;
  gap: var(--spacing-3);
  width: 100%;
  padding: 9px 14px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-family: inherit;
  text-align: left;
}

.attnRow:hover {
  background: var(--color-primary-lightest);
}

.attnMain {
  flex: 1;
  min-width: 0;
}

/* design: .cmd__res-title */
.attnName {
  font-size: var(--font-size-m);
  color: var(--color-text);
}

/* design: .cmd__res-sub */
.attnSub {
  font-size: var(--font-size-s);
  color: var(--color-grey);
  margin-top: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.empty {
  color: var(--color-grey);
  font-size: var(--font-size-m);
}

.note {
  color: var(--color-grey-light);
  font-size: var(--font-size-s);
}

/* product-usage list (per product: orgs · full users · invited) */
.prodList {
  display: flex;
  flex-direction: column;
}

.prodRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-3);
  padding: 13px 16px;
  border-top: 1px solid var(--color-grey-lightest);
  flex-wrap: wrap;
}

.prodRow:first-child {
  border-top: none;
}

.prodName {
  font-size: var(--font-size-m);
  color: var(--color-text);
}

.prodStats {
  display: flex;
  gap: 14px;
}

.prodStat {
  font-size: var(--font-size-m);
  color: var(--color-grey);
  white-space: nowrap;
}

.prodStat strong {
  color: var(--color-text);
  font-weight: 600;
}
